export enum ScoringToolSteps {
  UPLOAD,
  FINISH,
}
